import React, { useContext, useEffect } from "react";

import forOwn from "lodash/forOwn";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";

import { SearchContext } from "components/store/source/";
import { DEFAULT_AMENITIES } from "components/store/source/constants";
import { usePrevious, Button, Text } from "components/ui/source";

type ApplyMobileFiltersButtonProps = {
  setQuery?(query: { query?: Record<string, unknown>; value?: string }): void;
  onClose?(): void;
  buttonText?: string;
};

export function ApplyMobileFiltersButton({
  setQuery = () => {},
  buttonText = "",
  onClose = () => {},
}: ApplyMobileFiltersButtonProps) {
  const { criteria } = useContext(SearchContext);
  const { amenities } = criteria;
  const prevAmenities = usePrevious({ amenities });

  const generateQuery = () => {
    const query = [];
    forOwn(amenities, (value, key) => {
      if (typeof value === "boolean") {
        query.push({
          match: {
            [key]: {
              query: value,
            },
          },
        });
      } else {
        query.push({
          range: {
            [key]: {
              gte: value,
            },
          },
        });
      }
    });
    return query;
  };

  const applyAmenitiesFilters = () => {
    if (isEmpty(amenities)) {
      const req = {
        query: {
          match_all: {},
        },
      };
      return setQuery({
        query: req,
        value: "",
      });
    }

    const query = generateQuery();
    if (!isEmpty(query)) {
      const request = {
        query: {
          bool: {
            must: query,
          },
        },
      };
      return setQuery({
        query: request,
        value: `${JSON.stringify(amenities)}`,
      });
    }
  };

  useEffect(() => {
    if (
      !isEqual(amenities, DEFAULT_AMENITIES) ||
      (!!prevAmenities && !isEqual(prevAmenities, amenities))
    ) {
      applyAmenitiesFilters();
    }
  }, [amenities]);

  return (
    <Button onClick={onClose} upperCase={false}>
      <Text translateKey={buttonText} types={["caption1", "spaced"]} />
    </Button>
  );
}
